import {
  type AutocompleteOwnerState,
  type AutocompleteRenderValue,
  type AutocompleteRenderValueGetItemProps,
} from '@mui/material'
import { Box } from '../../../primitives/Box'
import { Chip } from '../../../primitives/Chip'

export const renderMultipleValue = <
  Value,
  Multiple extends boolean,
  DisableClearable extends boolean,
  FreeSolo extends boolean,
>(
  value: AutocompleteRenderValue<Value, Multiple, FreeSolo>,
  getItemProps: AutocompleteRenderValueGetItemProps<Multiple>,
  {
    getOptionLabel,
    open,
    limitTags = -1,
    disabled: autoCompleteIsDisabled,
  }: AutocompleteOwnerState<Value, Multiple, DisableClearable, FreeSolo>
) => {
  if (!Array.isArray(value)) {
    return null
  }

  const visibleValues = limitTags < 0 ? value : value.slice(0, limitTags)
  const hiddenCount = value.length - visibleValues.length

  return (
    <Box className="DhlAutocomplete-tags-root">
      {(open ? value : visibleValues).map((option, index) => {
        const { onDelete, 'data-item-index': dii, disabled } = getItemProps({ index })
        return (
          <Chip
            size="small"
            key={`autocomplete-chip-${dii}`}
            disabled={disabled}
            onDelete={onDelete}
            label={getOptionLabel(option)}
          />
        )
      })}
      {!open && hiddenCount > 0 && (
        <Box className="DhlAutocomplete-chip-more">
          <Chip
            size="small"
            variant="outlined"
            key="autocomplete-chip-more"
            label={`+${hiddenCount}`}
            color="dark"
            disabled={autoCompleteIsDisabled}
          />
        </Box>
      )}
    </Box>
  )
}
